import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import './navbaruser.css';
import { useTranslation } from 'react-i18next';
import api from '../../api/axios';

const NavbarUser = ({ setNavbarUserHeight }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    // scrolled für blackening
    const [scrolled, setScrolled] = useState(false);
    // Dropdown-Menü
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [profilbildBase64, setProfilbildBase64] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [pictureSrc, setPictureSrc] = useState("");

    const Menu = () => (
        <>
            <p><a href="#home" onClick={() => navigate('/')}>{t('Home')}</a></p>
            <p><a href="#concept" onClick={() => navigate('/#concept')}>{t('Concept')}</a></p>
            <p><Link to="/eventsstore">{t('EventStoreNav')}</Link></p>
            <p><a href="#dates" onClick={() => navigate('/#dates')}>{t('Calender')}</a></p>
            <p><a href="#faq" onClick={() => navigate('/#faq')}>{t('FAQ')}</a></p>
        </>
    );

    // Höhe berechnen für Anschluss-Div
    useEffect(() => {
        if (setNavbarUserHeight) {
            const navbarUserElement = document.querySelector('.navbarUser');
            if (navbarUserElement) {
                const navbarUserHeight = navbarUserElement.offsetHeight;
                setNavbarUserHeight(navbarUserHeight);
            }
        }

        const fetchPicture = async () => {
            try {
                const pictureId = 6; // 🔹 hardcoded for now, can vary per site later
                const response = await api.get(`/user/getwebsitepicture/${pictureId}`);
                setPictureSrc(response.data.picture); // base64 string
            } catch (err) {
                console.error("Error fetching picture:", err);
            }
        };

        fetchPicture();
    }, [setNavbarUserHeight]);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 0;
            setScrolled(isScrolled);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    useEffect(() => {
        const fetchUserNavbarData = async () => {
            try {
                const [profilePicRes, adminRes] = await Promise.all([
                    api.get("/user/api/profile-picture"),
                    api.get("/user/check-eventsadmin"),
                ]);

                if (profilePicRes.data?.base64) {
                    setProfilbildBase64(`data:image/jpeg;base64,${profilePicRes.data.base64}`);
                }

                setIsAdmin(adminRes.data?.isAdmin ?? false);
            } catch (err) {
                console.error("Navbar user data error:", err);
            }
        };

        fetchUserNavbarData();
    }, []);

    // Logo onclick
    function navigateHomeAndScrollToTop() {
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userData");
        navigate("/");
        window.location.reload();
    };

    return (
        <div className={`navbarUser ${scrolled ? "scrolled" : ""}`}>
            {pictureSrc ? (
                <img className="logo" onClick={navigateHomeAndScrollToTop} src={pictureSrc} alt="Barmatch" />
            ) : (
                <p>Loading logo...</p>
            )}
            <nav className="navigation">
                <Menu></Menu>
                <button id="profileButton" onClick={toggleDropdown}>

                    <img
                        src={profilbildBase64}
                        alt="Profil"
                        className="profile-image"
                    />
                </button>
                {dropdownOpen && (
                    <div className="dropdown-content">
                        <Link to="/profile">{t('Profile')}</Link>
                        <Link to="/profile/myevents">{t('MyEvents')}</Link>
                        <Link to="/eventsstore">{t('EventsStore')}</Link>
                        {isAdmin && <Link to="/profile/eventsadmin">{t('EventsAdmin')}</Link>}
                        <Link to="/" onClick={handleLogout}>{t('Logout')}</Link>
                    </div>
                )}
            </nav>
        </div>
    )
}

export default NavbarUser